import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "sorting" }

import SortItems from '@/components/common/SortItems.vue';
import { Story, StoryType } from '@/models/story.model';
import { ShiftCMSState } from '@/store';
import { CategoriesState } from '@/stores/categories.store';
import { StoriesActions, StoriesState } from '@/stores/stories.store';
import { computed, onMounted } from 'vue';
import { useStore } from 'vuex';


export default /*@__PURE__*/_defineComponent({
  __name: 'StoriesSorting',
  setup(__props) {

const store = useStore<
  ShiftCMSState & { ts: StoriesState; cs: CategoriesState }
>();
const stories = computed<Story[]>(() => store.state.ts.stories);

onMounted(() => {
  store.dispatch(StoriesActions.GetStories);
});

const saveSorted = (storySorting: number[]) => {
  store.dispatch(StoriesActions.UpdateStorySorting, storySorting);
};

return (_ctx: any,_cache: any) => {
  const _component_v_alert = _resolveComponent("v-alert")!
  const _component_v_container = _resolveComponent("v-container")!

  return (_openBlock(), _createBlock(_component_v_container, null, {
    default: _withCtx(() => [
      _cache[3] || (_cache[3] = _createElementVNode("h2", null, "Quiz of the day - Sorting", -1)),
      _createVNode(_component_v_alert, {
        type: "info",
        class: "mb-4"
      }, {
        default: _withCtx(() => _cache[1] || (_cache[1] = [
          _createTextVNode(" Sort the stories on this screen. Users will encounter these stories as quiz of the day, in this order, unless a preference for a specific category is set. ")
        ])),
        _: 1
      }),
      _createVNode(_component_v_alert, {
        type: "warning",
        class: "mb-4"
      }, {
        default: _withCtx(() => _cache[2] || (_cache[2] = [
          _createTextVNode(" Changing the order here might give people strange results ")
        ])),
        _: 1
      }),
      _createElementVNode("div", _hoisted_1, [
        _createVNode(SortItems, {
          "show-id": "",
          items: 
          [...stories.value]
            .filter((s) => s.published)
            .filter((s) => s.type === _unref(StoryType).Quiz)
        ,
          order: stories.value.sort((a, b) => a.index - b.index).map((s) => s.id),
          onChange: _cache[0] || (_cache[0] = (ids) => saveSorted(ids))
        }, null, 8, ["items", "order"])
      ])
    ]),
    _: 1
  }))
}
}

})